/* unplugin-vue-components disabled */import script from "./consentBanner.vue?vue&type=script&lang=js"
export * from "./consentBanner.vue?vue&type=script&lang=js"

import "./consentBanner.vue?vue&type=style&index=0&id=86bb07e4&lang=scss"

const __exports__ = script;

export default __exports__